
import css from './GenerateTnaDocument.module.css';

function GenerateTnaDocument( ) {



    const generateDocument = () => {
        alert('TNA Document generation is not yet implemented.');
    }
  return (
            <div>
              <button className={css.button} onClick={generateDocument}>Download</button>
            </div>
          );
}

export default GenerateTnaDocument;